import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-70f6f5e4")

_pushScopeId("data-v-70f6f5e4")
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "symbol symbol-45px custom" }
const _hoisted_3 = {
  key: 0,
  class: "badge badge-light-primary"
}
const _hoisted_4 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("i", { class: "fas fa-ellipsis-h" }, null, -1)
const _hoisted_6 = { class: "menu-item-wrapper" }
const _hoisted_7 = {
  key: 0,
  class: "menu-item"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
const _hoisted_9 = {
  key: 1,
  class: "menu-item"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "svg-icon svg-icon-3" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-clipboard-list" })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_AdvanceSearch = _resolveComponent("AdvanceSearch")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loader }, null, 8, ["loading"]),
    _createVNode(_component_AdvanceSearch, {
      filter: true,
      filterOption: _ctx.filterOption,
      status: _ctx.statusList,
      onExportFile: _ctx.exportFile,
      onSearch: _ctx.searchHandler,
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.reloadReportListing(1, true))),
      dateFilter: true
    }, null, 8, ["filterOption", "status", "onExportFile", "onSearch"]),
    _createVNode(_component_Table, {
      loading: _ctx.loader,
      columns: _ctx.columns,
      rows: _ctx.reports,
      pagination: _ctx.pagination,
      padding: 2,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      onSorting: _ctx.searchHandler
    }, _createSlots({
      "cell-avatar": _withId(({ row: item }) => [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "navatar",
            style: 'background-color:' + _ctx.generateAvatar(item?.user?.name)?.color
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.generateAvatar(item?.user?.name)?.name), 1)
          ], 4)
        ])
      ]),
      "cell-name": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.user?.name), 1)
      ]),
      "cell-email": _withId(({ row: item }) => [
        _createTextVNode(_toDisplayString(item?.user?.email), 1)
      ]),
      "cell-status": _withId(({ row: item }) => [
        (item?.user?.status == 1)
          ? (_openBlock(), _createBlock("span", _hoisted_3, _toDisplayString(_ctx.$t('message.ACTIVE')), 1))
          : (_openBlock(), _createBlock("span", _hoisted_4, _toDisplayString(_ctx.$t('message.INACTIVE')), 1))
      ]),
      "cell-actions": _withId(({ row: item }) => [
        _createVNode("button", {
          class: "action-btn",
          type: "button",
          onClick: ($event: any) => (_ctx.dropdownHandler(_ctx.activeIndex, item?.id))
        }, [
          _hoisted_5,
          _createVNode("div", {
            class: ["dropdown-menu dropdown-menu-end action-dropdown", { active: _ctx.activeIndex === item?.id }]
          }, [
            _createVNode("div", _hoisted_6, [
              (_ctx.$can('view_customer'))
                ? (_openBlock(), _createBlock("div", _hoisted_7, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleView(item)),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_8,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.$can('view_customer') && _ctx.active_provider != 'Sap')
                ? (_openBlock(), _createBlock("div", _hoisted_9, [
                    _createVNode("a", {
                      onClick: ($event: any) => (_ctx.handleOrderView(item?.orders[0])),
                      class: "menu-link me-1"
                    }, [
                      _hoisted_10,
                      _createTextVNode(" " + _toDisplayString(_ctx.$t('message.VIEW_ORDER_DETAILS')), 1)
                    ], 8, ["onClick"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ], 8, ["onClick"])
      ]),
      _: 2
    }, [
      (_ctx.active_provider == 'Sap')
        ? {
            name: "cell-modified_date",
            fn: _withId(({ row: item }) => [
              _createTextVNode(_toDisplayString(item?.invoices[0].modified_date) + " " + _toDisplayString(_ctx.lastOrderplaced(item?.invoices[0]?.modified_date)), 1)
            ])
          }
        : {
            name: "cell-modified_date",
            fn: _withId(({ row: item }) => [
              _createTextVNode(_toDisplayString(item?.orders[0].created_at) + " " + _toDisplayString(_ctx.lastOrderplaced(item?.orders[0]?.created_at)), 1)
            ])
          }
    ]), 1032, ["loading", "columns", "rows", "pagination", "onHandleCurrentChange", "onSorting"])
  ]))
})